// Import model
import { PostalCodeField } from '../models/PostalCodeField';

// Import base class serializer
import { FieldSerializer } from './FieldSerializer';

// Import dependency types (models and enums used in properties)
import { FieldOptions } from '../models/FieldOptions';

// Import dependency serializers (for complex types)
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for PostalCodeField - handles JSON serialization and deserialization with type validation
 */
export class PostalCodeFieldSerializer {
  /**
   * Deserializes a JSON string into a PostalCodeField instance
   */
  static deserialize(json: string): PostalCodeField {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a PostalCodeField instance
   */
  static fromObject(obj: any): PostalCodeField {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to PostalCodeField');
    }


    const instance: PostalCodeField = {
      t: obj['_t'] as string,
      description: obj['Description'] as string | undefined,
      apiName: obj['ApiName'] as string | undefined,
      defaultValue: obj['DefaultValue'] as any | undefined,
      isRequired: obj['IsRequired'] as boolean | undefined,
      options: obj['Options'] ? FieldOptionsSerializer.fromObject(obj['Options']) : undefined as any,
      name: obj['Name'] as string,
      label: obj['Label'] as string | undefined,
      enable: obj['Enable'] ? (obj['Enable'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      visible: obj['Visible'] ? (obj['Visible'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      _1083Bdb6: obj['_1083bdb6'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of PostalCodeField instances
   */
  static deserializeArray(json: string): PostalCodeField[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a PostalCodeField instance to a JSON string
   */
  static serialize(instance: PostalCodeField): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a PostalCodeField instance to a plain object
   */
  static toObject(instance: PostalCodeField): any {
    return {
      '_t': instance.t,
      'Description': instance.description,
      'ApiName': instance.apiName,
      'DefaultValue': instance.defaultValue,
      'IsRequired': instance.isRequired,
      'Options': instance.options ? FieldOptionsSerializer.toObject(instance.options) : undefined,
      'Name': instance.name,
      'Label': instance.label,
      'Enable': instance.enable?.map((item: any) =>
        item
      ),
      'Visible': instance.visible?.map((item: any) =>
        item
      ),
      '_1083bdb6': instance._1083Bdb6,
    };
  }

  /**
   * Serializes an array of PostalCodeField instances to a JSON string
   */
  static serializeArray(instances: PostalCodeField[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
